import { Outlet } from 'react-router-dom';
import InvoicesTabs from './InvoicesTabs';

/** Persistent tab bar for the Sąskaitos module; content swaps below via Outlet. */
export default function InvoicesLayout() {
  return (
    <div className="space-y-4">
      <InvoicesTabs />
      <Outlet />
    </div>
  );
}
